const API_URL = 'https://frostandgrey-backend.onrender.com';
// const API_URL = 'http://localhost:4500'

export default API_URL;
